<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="status"
                        :options="optionsStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                      <div class="input-group-btn">
                        <div class="btn-group">
                          <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                          <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                        </div>
                      </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      cd: '',
      descr: '',
      optionsTipoUnidade: [],
      tp_unidade: [],
      optionsStatus: [],
      status: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getTipoUnidade();
      this.getStatus();
      this.getTipoDoc();
      this.getMunicipio();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              cnpj: this.cnpj,
                              razao_social: this.razao_social,
                              descr: this.descr,
                              tp_unidade: this.tp_unidade,
                              status: this.status,
                              municipio: this.municipio,
                              tipo_doc: this.tipo_doc}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.descr= '';
        this.cnpj= '';
        this.razao_social= '';
        this.tp_unidade = '';
        this.status = '';
        this.municipio = '';
        this.tipo_doc = '';
        this.$events.fire('filter-reset');
      },
      getTipoUnidade() {
          this.helpForm.params = { tabela: 'unidade',
                                  coluna: 'tp_unidade' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsTipoUnidade.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getStatus() {
          this.helpForm.params = { tabela: 'unidade',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsStatus.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getTipoDoc() {
          this.helpForm.get('/api/paramtipodoc/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsTipoDoc.push({ label: obj.descr, value: obj.partipdoc_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getMunicipio() {
          this.helpForm.get('/api/municipio/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      }
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
